export default __webpack_public_path__ + "static/media/img-0680-bosnia-full-face.4af45494.png";